import { useState } from "react"
import { professorRequest } from "services/requests"
import { getAccount } from "services/parentBridge"
import { isRunningFromIframe } from "common/functions"

const prefix = "account"

export const useProfessorAccountApi = () => {
  const [isFetching, setIsFetching] = useState(false)

  const getUser = async () => {
    setIsFetching(true)
    let user = null
    if (isRunningFromIframe()) {
      user = await getAccount()
    } else {
      const response = await professorRequest.sendRequest({
        endpoint: `${prefix}`,
        method: "get",
      })
      user = response.data
    }
    setIsFetching(false)
    return user
  }

  const changePassword = async (currentPassword, newPassword) => {
    setIsFetching(true)
    try {
      return await professorRequest.sendRequest({
        endpoint: `${prefix}/changePassword`,
        body: {
          currentPassword,
          newPassword,
        },
        method: "post",
      })
    } finally {
      setIsFetching(false)
    }
  }

  const editAccount = async (formData) => {
    setIsFetching(true)
    try {
      return await professorRequest.sendFormData({
        endpoint: `${prefix}/edit`,
        formData,
      })
    } finally {
      setIsFetching(false)
    }
  }

  const configurationCompleted = async () => {
    setIsFetching(true)
    try {
      return await professorRequest.sendRequest({
        endpoint: `${prefix}/configurationCompleted`,
        method: "post",
      })
    } finally {
      setIsFetching(false)
    }
  }

  const createAccount = async ({
    code,
    languageId,
    account,
    institution,
    schooling,
    ssoUser,
    recaptchaToken,
  }) => {
    setIsFetching(true)
    try {
      const body = {
        code,
        languageId,
        account,
        institution,
        schooling,
        ssoUser,
        recaptchaToken,
      }

      Object.keys(body).forEach(
        (key) => body[key] === undefined && delete body[key]
      )

      return await professorRequest.sendRequest({
        endpoint: `${prefix}/create`,
        body,
        method: "post",
      })
    } finally {
      setIsFetching(false)
    }
  }

  const updateInterfaceLanguage = async (languageId, otherOptions = {}) => {
    setIsFetching(true)
    try {
      return await professorRequest.sendRequest({
        endpoint: `${prefix}/interfaceLanguage`,
        body: { languageId },
        method: "put",
        otherOptions,
      })
    } finally {
      setIsFetching(false)
    }
  }

  return {
    isFetching,
    changePassword,
    editAccount,
    configurationCompleted,
    createAccount,
    updateInterfaceLanguage,
    getUser,
  }
}

export default useProfessorAccountApi
